import React from 'react';
import { Box } from '@mui/material';
import SubscriptionRenewalAlert from './SubscriptionRenewalAlert';

interface SubscriptionNotificationsProps {
  onClose?: () => void;
}

const SubscriptionNotifications: React.FC<SubscriptionNotificationsProps> = ({
  onClose
}) => {
  return (
    <Box sx={{ position: 'fixed', top: 24, right: 24, zIndex: 1000 }}>
      <SubscriptionRenewalAlert onClose={onClose} />
    </Box>
  );
};

export default SubscriptionNotifications; 